export const Flag = ({
  color = 'currentColor',
  className,
}: {
  color?: string;
  className?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.125 16.875V3.75H17.5L13.75 8.4375L17.5 13.125H3.125"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
